import { render, staticRenderFns } from "./vSidebar.vue?vue&type=template&id=57b51a12"
import script from "./vSidebar.vue?vue&type=script&lang=js"
export * from "./vSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports